import React from 'react';
import ReactDOM from 'react-dom/client';
// Self-host Plus Jakarta Sans (bundled by webpack) so the font works offline / behind the ingress,
// instead of pulling it from fonts.googleapis.com at runtime.
import '@fontsource/plus-jakarta-sans/300.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/400-italic.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

// Note: React.StrictMode is disabled because it causes Keycloak to be initialized twice
// This is a known issue with Keycloak and React.StrictMode in development
// Re-enable in production builds if needed
root.render(<App />);
